import { render, staticRenderFns } from "./TranslationsTypes.vue?vue&type=template&id=1f1e16d9&scoped=true&"
import script from "./TranslationsTypes.vue?vue&type=script&lang=js&"
export * from "./TranslationsTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e16d9",
  null
  
)

export default component.exports